import React from 'react';

interface RightTwoArrowCircleProps {
  height: number;
  width: number;
}

const RightTwoArrowCircle: React.FC<RightTwoArrowCircleProps> = ({
  width,
  height,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform={`translate(${(width - 22) / 2}, ${(height - 22) / 2})`}>
        <circle cx="11" cy="11" r="11" fill="#1890FF" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.7345 6.23468C7.76933 6.19976 7.81071 6.17205 7.85627 6.15315C7.90183 6.13424 7.95067 6.12451 8 6.12451C8.04932 6.12451 8.09817 6.13424 8.14372 6.15315C8.18928 6.17205 8.23066 6.19976 8.2655 6.23468L12.7655 10.7347C12.8004 10.7695 12.8281 10.8109 12.847 10.8565C12.8659 10.902 12.8757 10.9509 12.8757 11.0002C12.8757 11.0495 12.8659 11.0983 12.847 11.1439C12.8281 11.1895 12.8004 11.2308 12.7655 11.2657L8.2655 15.7657C8.19508 15.8361 8.09958 15.8757 8 15.8757C7.90042 15.8757 7.80491 15.8361 7.7345 15.7657C7.66408 15.6953 7.62453 15.5998 7.62453 15.5002C7.62453 15.4006 7.66408 15.3051 7.7345 15.2347L11.9697 11.0002L7.7345 6.76568C7.69958 6.73085 7.67187 6.68947 7.65296 6.64391C7.63406 6.59835 7.62433 6.54951 7.62433 6.50018C7.62433 6.45086 7.63406 6.40202 7.65296 6.35646C7.67187 6.3109 7.69958 6.26952 7.7345 6.23468Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7345 6.23468C10.7693 6.19976 10.8107 6.17205 10.8563 6.15315C10.9018 6.13424 10.9507 6.12451 11 6.12451C11.0493 6.12451 11.0982 6.13424 11.1437 6.15315C11.1893 6.17205 11.2307 6.19976 11.2655 6.23468L15.7655 10.7347C15.8004 10.7695 15.8281 10.8109 15.847 10.8565C15.8659 10.902 15.8757 10.9509 15.8757 11.0002C15.8757 11.0495 15.8659 11.0983 15.847 11.1439C15.8281 11.1895 15.8004 11.2308 15.7655 11.2657L11.2655 15.7657C11.1951 15.8361 11.0996 15.8757 11 15.8757C10.9004 15.8757 10.8049 15.8361 10.7345 15.7657C10.6641 15.6953 10.6245 15.5998 10.6245 15.5002C10.6245 15.4006 10.6641 15.3051 10.7345 15.2347L14.9697 11.0002L10.7345 6.76568C10.6996 6.73085 10.6719 6.68947 10.653 6.64391C10.6341 6.59835 10.6243 6.54951 10.6243 6.50018C10.6243 6.45086 10.6341 6.40202 10.653 6.35646C10.6719 6.3109 10.6996 6.26952 10.7345 6.23468Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default RightTwoArrowCircle;
